import React, { useEffect, useState } from 'react'
import useStore from '../../ProductStore/Store'
import About from './About/About'
import Categorization from './Categorization/Categorization'
import Description from './Description/Description'
import KeywordFeature from './Keyword/KeywordFeature'
import MostRecentPrice from './MostRecentPrice/MostRecentPrice'
import MostRecentPriceDate from './MostRecentPriceDate/MostRecentPriceDate'
import RecordRecency from './RecordRecency/RecordRecency'
import RequiredFields from './RequiredFields/RequiredFields'
import ReviewsRating from './ReviewsRating/ReviewsRating'
import { default as styles, default as stylesModal } from './styles.module.css' // Assuming you have a CSS module with the required stylesModal
import useEscapeKey from '../../../utils/useEscapeKey'

function ExpandedModal ({ onClose }) {
  const {
    name,
    setName,
    isQueryLoading,
    resetStore,
    queryStore,
    GTIN,
    setGTIN,
    SKUS,
    setSKUS,
    brandManufacturer,
    setBrandManufacturer,
    primaryCategories,
    setPrimaryCategories,
    taxonomyLevel1,
    setTaxonomyLevel1,
    taxonomyLevel2,
    setTaxonomyLevel2,
    taxonomyLevel3,
    setTaxonomyLevel3,
    rawCategory,
    rentalPrice,
    setRentalPrice,
    setRawCategory,
    mostRecentPriceDate,
    setMostRecentPriceDate,
    description,
    setDescription,
    recordRecency,
    setRecordRecency,
    featureKeyword,
    setFeatureKeyword,
    requiredFields,
    setRequiredFields,
    reviewsRangeQuery,
    setReviewsRangeQuery,
    manufacturerNumber,
    setManufacturerNumber
  } = useStore()
  const [isVisible, setIsVisible] = useState(false)

  const [localName, setLocalName] = useState(name)
  const [localGTIN, setLocalGTIN] = useState(GTIN)
  const [localSKUS, setLocalSKUS] = useState(SKUS)
  const [localBrandManufacturer, setLocalBrandManufacturer] =
    useState(brandManufacturer)
  const [localTaxonomyLevel1, setLocalTaxonomyLevel1] = useState(taxonomyLevel1)
  const [localTaxonomyLevel2, setLocalTaxonomyLevel2] = useState(taxonomyLevel2)
  const [localTaxonomyLevel3, setLocalTaxonomyLevel3] = useState(taxonomyLevel3)
  const [localPrimaryCategories, setLocalPrimaryCategories] =
    useState(primaryCategories)
  const [localRawCategory, setLocalRawCategory] = useState(rawCategory)
  const [localRentalPrice, setLocalRentalPrice] = useState(rentalPrice)
  const [localMostRecentPriceDate, setLocalMostRecentPriceDate] =
    useState(mostRecentPriceDate)
  const [localDescription, setLocalDescription] = useState(description)

  const [localRecordRecency, setLocalRecordRecency] = useState(recordRecency)

  const [localFeatureKeyword, setLocalFeatureKeyword] = useState(featureKeyword)
  const [localRequiredFields, setLocalRequiredFields] = useState(requiredFields)
  const [localReviewsRangeQuery, setLocalReviewsRangeQuery] = useState(reviewsRangeQuery)

  const [localManufacturerNumber, setLocalManufacturerNumber] = useState(manufacturerNumber)


  // Function to handle backdrop click
  const handleBackdropClick = event => {
    // Check if the clicked element is the backdrop itself, not its children
    if (event.target === event.currentTarget) {
      setIsVisible(false)
      setTimeout(() => {
        onClose()
      }, 250)
    }
  }

  const handleClose = () => {
    // Start the slide-out effect
    setIsVisible(false)
    // Use a timeout to match the CSS transition duration
    setTimeout(() => {
      onClose()
    }, 250)
  }

  useEscapeKey(handleClose)

  useEffect(() => {
    // Trigger the slide-in effect when the component mounts
    const timeoutId = setTimeout(() => {
      setIsVisible(true)
    }, 1)

    return () => clearTimeout(timeoutId)
  }, [])

  useEffect(() => {
    if (isQueryLoading) {
      handleClose()
    }
  }, [isQueryLoading]) /* eslint-disable-line react-hooks/exhaustive-deps */

  const handleApplyFilters = () => {
    // Only proceed if not already loading
    if (!isQueryLoading) {
      // Update all filters, including price filter state
      // close
      setName(localName)
      setGTIN(localGTIN)
      setSKUS(localSKUS)
      setBrandManufacturer(localBrandManufacturer)
      setTaxonomyLevel1(localTaxonomyLevel1)
      setTaxonomyLevel2(localTaxonomyLevel2)
      setTaxonomyLevel3(localTaxonomyLevel3)
      setPrimaryCategories(localPrimaryCategories)
      setRawCategory(localRawCategory)
      setRentalPrice(localRentalPrice)
      setMostRecentPriceDate(localMostRecentPriceDate)
      setDescription(localDescription)
      setRecordRecency(localRecordRecency)
      setFeatureKeyword(localFeatureKeyword)
      setRequiredFields(localRequiredFields)
      setReviewsRangeQuery(localReviewsRangeQuery);
      setManufacturerNumber(localManufacturerNumber);

      setIsVisible(false)
      setTimeout(() => {
        onClose()
      }, 250)
    }
  }
  const handleClearFilters = () => {
    if (queryStore) {
      resetStore()
    }
    setLocalName('')
    setLocalGTIN('')
    setLocalSKUS('')
    setLocalBrandManufacturer('')
    setLocalTaxonomyLevel1('')
    setLocalTaxonomyLevel2('')
    setLocalTaxonomyLevel3('')
    setLocalPrimaryCategories('')
    setLocalRawCategory('')
    setLocalRentalPrice('')
    setLocalMostRecentPriceDate('')
    setLocalDescription('')
    setLocalRecordRecency('')
    setLocalBrandManufacturer('')
    setLocalRequiredFields('')
    setLocalReviewsRangeQuery('')
    setLocalManufacturerNumber('')
    handleClose()
  }

  return (
    <div className={stylesModal.modalBackdrop} onClick={handleBackdropClick}>
      <div
        className={stylesModal.modalContent}
        style={{ transform: isVisible ? 'translateX(0)' : 'translateX(100%)' }}
        onClick={e => e.stopPropagation()}
      >
        <div className={stylesModal.modalHeader}>
          <h2 className={styles.ApiCallTitle}>Filters</h2>
          <div className={styles.containerButtonsFilters}>
            <span
              className={styles.buttonClearFilter}
              onClick={handleClearFilters}
            >
              Clear filters
            </span>
            <button
              className={styles.buttonApplyFilters}
              onClick={handleApplyFilters}
            >
              Apply filters
            </button>
          </div>
        </div>
        <hr className={styles.hrExpandedModal} />
        <About
          localName={localName}
          setLocalName={setLocalName}
          isQueryLoading={isQueryLoading}
          localGTIN={localGTIN}
          setLocalGTIN={setLocalGTIN}
          localSKUS={localSKUS}
          setLocalSKUS={setLocalSKUS}
          localBrandManufacturer={localBrandManufacturer}
          setLocalBrandManufacturer={setLocalBrandManufacturer}
          localManufacturerNumber={localManufacturerNumber}
          setLocalManufacturerNumber={setLocalManufacturerNumber}
        />
        <hr className={styles.hrExpandedModal} />
        <div style={{ marginTop: '24px', marginBottom: '24px' }}>
          <Categorization
            localTaxonomyLevel1={localTaxonomyLevel1}
            setLocalTaxonomyLevel1={setLocalTaxonomyLevel1}
            //
            localTaxonomyLevel2={localTaxonomyLevel2}
            setLocalTaxonomyLevel2={setLocalTaxonomyLevel2}
            //
            localTaxonomyLevel3={localTaxonomyLevel3}
            setLocalTaxonomyLevel3={setLocalTaxonomyLevel3}
            //
            localPrimaryCategories={localPrimaryCategories}
            setLocalPrimaryCategories={setLocalPrimaryCategories}
            //
            localRawCategory={localRawCategory}
            setLocalRawCategory={setLocalRawCategory}
          />
        </div>
        <hr className={styles.hrExpandedModal} />
        <div style={{ marginTop: '24px', marginBottom: '24px' }}>
          <h1 style={{ marginBottom: '10px', fontSize: '14px' }}>Price</h1>
          <div style={{ display: 'flex', gap: '40px' }}>
            <MostRecentPrice
              localRentalPrice={localRentalPrice}
              setLocalRentalPrice={setLocalRentalPrice}
            />

            <MostRecentPriceDate
              localMostRecentPriceDate={localMostRecentPriceDate}
              setLocalMostRecentPriceDate={setLocalMostRecentPriceDate}
            />
          </div>
        </div>
        <hr className={styles.hrExpandedModal} />

        <Description
          localDescription={localDescription}
          setLocalDescription={setLocalDescription}
        />

        <hr className={styles.hrExpandedModal} />

        <ReviewsRating
          localReviewsRangeQuery={localReviewsRangeQuery}
          setLocalReviewsRangeQuery={setLocalReviewsRangeQuery}
        />

        <hr className={styles.hrExpandedModal} />

        <RecordRecency
          localRecordRecency={localRecordRecency}
          setLocalRecordRecency={setLocalRecordRecency}
        />

        <hr className={styles.hrExpandedModal} />

        <KeywordFeature
          localFeatureKeyword={localFeatureKeyword}
          setLocalFeatureKeyword={setLocalFeatureKeyword}
        />

        <hr className={styles.hrExpandedModal} />

        <RequiredFields
          localRequiredFields={localRequiredFields}
          setLocalRequiredFields={setLocalRequiredFields}
        />

        <hr className={styles.hrExpandedModal} />
      </div>
    </div>
  )
}

export default ExpandedModal
